import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Angulartics2Module } from 'angulartics2';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { CommonUiModule } from '@tablesready/common-ui';
import { BadgeModule } from '@tablesready/frontend-badge';
import { FrontendCountdownTimerModule } from '@tablesready/frontend-countdown-timer';
import { DateFormatPipe } from '@tablesready/frontend-pipes';

import { PartyTableComponent } from './party-table.component';
import { TrTableModule } from '../tr-table';
import { ClosePopoverOnScrollDirective } from '../../directives';
import { WaitlistMessagesModule } from '../waitlist-messages';
import { WaitlistActionsModule } from '../waitlist-actions';
import { WaitlistQuotedTimeModule } from '../waitlist-quoted-time';

@NgModule({
  declarations: [PartyTableComponent],
  exports: [PartyTableComponent],
  imports: [
    CommonModule,
    TrTableModule,
    Angulartics2Module,
    NgbPopoverModule,
    ClosePopoverOnScrollDirective,
    CommonUiModule,
    BadgeModule,
    FrontendCountdownTimerModule,
    DateFormatPipe,
    WaitlistMessagesModule,
    WaitlistActionsModule,
    WaitlistQuotedTimeModule,
  ],
})
export class PartyTableModule {}
